export default "__VITE_ASSET__BU9hwBLU__"